<template>
  <div class="form-group">
    <select @change="getPatientById($event.target.value)" class="form-select">
      <option :value="INIT_NO_OP_NUM">Choose a patient</option>
      <option v-for="p in patientList" :key="p.id" :value="p.id" :disabled="p.heading">
        {{ p.description }}
      </option>
    </select>
  </div>
</template>
<script>
import router from '@/router/index';
import { mapGetters, mapActions } from 'vuex';
import { INIT_NO_OP_NUM } from '@/config';
import { getFormattedRelationsList } from '@/data/getters';
import { impersonate } from '@/api/sessionApi';

export default {
  name: 'relations-list',
  data() {
    return {
      INIT_NO_OP_NUM
    }
  },
  props: {
    relationsList: null
  },
  computed: {
    ...mapGetters('login', {
      allData: 'getAllData',
    }),
    patientList: function () {
      let data = this.allData;
      let result =  getFormattedRelationsList(data);
      return result;
    } 
  },
  methods: {
    getPatientById(id) {
      try {
        let loader = this.$loading.show({},{
            after: this.$createElement('div',{},['Switching accounts...'])
        });
        id = parseInt(id);
        impersonate(id)
        .then(()=>setTimeout(()=>{ 
          window.location.reload(); 
        },1000))
        .catch((e) => {
          console.log(e)
          setTimeout(()=>{ window.location.reload(); },3000);
        })
      } catch(e) {
          console.log(e)
          setTimeout(()=>{ window.location.reload(); },3000);
      }
    }
  }
}
</script>

<style scoped lang="scss">
  select {
    font-size: 0.9em;
  }
</style>
